function CardsFormCtrl(cardsService, toaster, $translate) {
  const ctrl = this;
  ctrl.onKeyDown = function (event, cardsFormBlock) {
    if (event.keyCode !== 13) {
      return;
    }

    // Не даём Enter инициировать submit всей формы чекаута — валидируем и применяем только блок купона
    event.preventDefault();
    event.stopPropagation();
    cardsFormBlock.$setDirty();
    cardsFormBlock.$setSubmitted();
    if (cardsFormBlock.$invalid) {
      return;
    }
    ctrl.apply(ctrl.code);
  };
  ctrl.apply = function (code) {
    if (code != null && code.length > 0) {
      cardsService.apply(code).then(data => {
        if (data.result === true && data.msg == null) {
          ctrl.applyFn();
        } else {
          ctrl.applyFn();
          toaster.pop('error', $translate.instant('Js.Cards.CantApplyCoupon'), data.msg);
        }
      });
    }
  };
}
CardsFormCtrl.$inject = ["cardsService", "toaster", "$translate"];
export default CardsFormCtrl;